<div class="dealer-locator">
  <h3 class="mt-2 dealer-locator-title">
    <img *ngIf="product?.manufacturer?.pictureUrl" [src]="product?.manufacturer?.pictureUrl" [alt]="product?.manufacturer?.name">
    <span *ngIf="!product?.manufacturer?.pictureUrl">{{product?.manufacturer?.name}} - Find a Retailer</span>
  </h3>
  <app-dealer-locator-map *ngIf="!preRender" #dealerLocatorMap></app-dealer-locator-map>
  <div *ngIf="preRender" style="width:100%; text-align: center;">
    <button mat-raised-button color="primary" (click)="showMap()">Show Dealer Locator Map</button>
  </div>
</div>
